import React, { useState, useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";

import Loader from "components/Loader";
import Header from "components/Header";
import Footer from "components/Footer";
import SEO from "components/SEO";

let location = "";

const Layout = ({ title, description }) => {
	const [loading, setLoading] = useState(false);
	location = useLocation();

	//setto scroll pagina a 0 quando viene cambiata route
	useEffect(() => {
		const handleStart = () => setLoading(true);
		const handleComplete = () => setLoading(false);

		handleStart();
		setTimeout(handleComplete, 1000); // Simula il tempo di caricamento, puoi rimuoverlo o modificarlo in base alle tue necessità

		return () => {
			handleComplete();
		};
	}, [location]);

	return (
		<>
			{loading && <Loader />}
			<SEO title={title} description={description} />

			<main style={{ overflow: "hidden" }}>
				{location.pathname.indexOf("home") > -1 ? "" : <Header />}

				<Outlet />

				{location.pathname.indexOf("home") > -1 ? "" : <Footer />}
			</main>
		</>
	);
};

export default Layout;
